import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";
import { Shield, Zap, Lock, Sparkles, Heart } from "lucide-react";

export const Route = createFileRoute("/es/about")({
  head: () => ({
    meta: [
      { title: "Sobre Nosotros — Picamini.online" },
      {
        name: "description",
        content:
          "Conoce la misión de Picamini.online: crear herramientas interactivas, privadas y gratuitas para profesores, estudiantes y organizadores de eventos en todo el mundo.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/es/sobre-nosotros" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/about" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/sobre-nosotros" },
    ],
  }),
  component: EsAboutPage,
});

function EsAboutPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="es" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-8">
        <div className="text-center space-y-3">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 border border-primary/20 px-4 py-1 text-xs font-bold text-primary">
            <Sparkles className="size-3.5" /> Sobre Picamini.online
          </span>
          <h1 className="text-3xl font-extrabold sm:text-4xl text-foreground">
            Herramientas Digitales Gratuitas y Privadas para Todos
          </h1>
          <p className="text-base text-muted-foreground leading-relaxed">
            Creemos que la tecnología educativa debe ser rápida, accesible y respetar la privacidad de los usuarios.
          </p>
        </div>

        <div className="surface-card p-6 sm:p-8 rounded-2xl bg-card border space-y-4">
          <h2 className="text-xl font-bold text-foreground flex items-center gap-2">
            <Heart className="size-5 text-primary" /> Nuestra Misión
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
            Picamini.online nació con el objetivo de ofrecer a docentes, dinamizadores de grupos y organizadores de eventos un conjunto de herramientas digitales ágiles, sin anuncios invasivos ni requisitos de registro. Desde ruletas de nombres hasta convertidores de PDF, todo funciona directamente en tu navegador.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-3">
          <div className="p-6 rounded-2xl border bg-card space-y-2">
            <Zap className="size-6 text-amber-500" />
            <h3 className="font-bold text-foreground">100% Gratis</h3>
            <p className="text-xs text-muted-foreground">Sin cuotas de suscripción, sin límites diarios ni sorpresas.</p>
          </div>

          <div className="p-6 rounded-2xl border bg-card space-y-2">
            <Lock className="size-6 text-emerald-500" />
            <h3 className="font-bold text-foreground">Privacidad Primero</h3>
            <p className="text-xs text-muted-foreground">Tus listas e información nunca salen de tu dispositivo local.</p>
          </div>

          <div className="p-6 rounded-2xl border bg-card space-y-2">
            <Shield className="size-6 text-blue-500" />
            <h3 className="font-bold text-foreground">Sin Registro</h3>
            <p className="text-xs text-muted-foreground">Acceso inmediato sin necesidad de crear usuario ni dar correo.</p>
          </div>
        </div>
      </main>

      <SiteFooter lang="es" />
    </div>
  );
}
